// extracted by mini-css-extract-plugin
export default {"hgroup":"HGroup_hgroup__zAg7z"};